module.exports = __webpack_public_path__ + "static/media/shop.423cb14a.svg";